/** Shared public-site facts — only values already used in repo compliance pages. */
export const PUBLIC_SITE = {
  productName: 'Linas AI',
  publicBaseUrl: 'https://www.linasaibot.com',
  contactEmail: 'support@linasaibot.com',
  heroTitle: 'Linas AI',
  heroHeadline: 'Talk to Linas. Linas talks to your customers.',
  heroKicker: 'AI customer care, trained by you',
  heroSupport:
    'Teach Linas about your business once. It replies across every connected channel—while you stay in control.',
  heroConnect: 'Connect once. Reply everywhere.',
  metaPlatformDataUse:
    'Linas AI is a business customer-support platform that helps companies answer customers using knowledge each business approves. With each client’s permission, we may process inquiries on Facebook, Instagram, WhatsApp, and TikTok when that client connects those accounts through official platform integrations. We use account details and customer messages from those platforms only to receive inquiries, send automated replies from approved business knowledge, support Owner chat and AI Setup for that client, and direct customers to the client’s chosen contact channel when booking or human assistance is needed. Each client connects only business accounts it owns or is authorized to manage.',
};

/**
 * Store listing status — do not invent App Store / Play IDs.
 * Update `url` when ASC / Play Console listings are live.
 */
export const STORE_LINKS = {
  appStore: {
    label: 'Download on the App Store',
    status: 'pending',
    /** Set to full https://apps.apple.com/app/id… when ASC listing is public. */
    url: null,
    blocker:
      'No public App Store URL or numeric Apple ID is committed in-repo yet (TestFlight / ASC gate still pending).',
  },
  playStore: {
    label: 'Get it on Google Play',
    status: 'pending',
    /** Set to https://play.google.com/store/apps/details?id=com.linasai.app when live. */
    url: null,
    packageName: 'com.linasai.app',
    blocker: 'Google Play listing for com.linasai.app is not live yet.',
  },
};

export const PUBLIC_PATHS = {
  home: '/',
  register: '/register',
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  verifyEmail: '/verify-email',
  about: '/about',
  contact: '/contact',
  pricing: '/pricing',
  features: '/features',
  privacy: '/privacy-policy',
  terms: '/terms',
  dataDeletion: '/data-deletion',
  appHome: '/app',
  getApp: '/#get-app',
  guestChat: '/#talk-to-linas',
};

/** Former operator SPA bookmarks → landing `#get-app`. Unknown paths still hit AppEntry. */
export const OBSOLETE_OPERATOR_PATHS = [
  '/mobile/live-chat',
  '/training',
  '/content-managers/*',
  '/activity-flow',
  '/live-chat',
  '/analytics',
  '/smart-messaging',
  '/social-posts',
  '/wallet',
  '/settings',
  '/testing',
  '/api-debug',
];

/**
 * Linas AI public social channels (footer). No Web Chat.
 * Set `url` to the live profile when available — until then links open a mailto to support.
 * Do not invent handles.
 */
export const PUBLIC_CHANNEL_LINKS = [
  { id: 'instagram', label: 'Instagram', url: null },
  { id: 'facebook', label: 'Facebook', url: null },
  { id: 'whatsapp', label: 'WhatsApp', url: null },
  { id: 'tiktok', label: 'TikTok', url: null },
];

/** @param {{ label: string, url?: string | null }} channel */
export function publicChannelHref(channel) {
  if (channel.url) return channel.url;
  const subject = encodeURIComponent(`Linas AI — ${channel.label}`);
  return `mailto:${PUBLIC_SITE.contactEmail}?subject=${subject}`;
}
